import { render } from "./user_popover.vue?vue&type=template&id=24c6ba41"
import script from "./user_popover.js?vue&type=script&lang=js"
export * from "./user_popover.js?vue&type=script&lang=js"

import "./user_popover.vue?vue&type=style&index=0&id=24c6ba41&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__